

class NavToggler extends CustomButton {
  get refs() {
    const $siteNav = $('#navbar'),
      navOverlay = document.querySelector('nav-overlay')


    return {
      $siteNav,
      $hamburgerIcon: this.$el.find('.hamburger-icon'),
      $closeIcon: this.$el.find('.close-icon'),
      navOverlay,
    }
  }

  constructor() {
    super()
  }

  setup() {
    this.setAccessibility()

    this.addEventListener('click', this.toggle)
  }

  setAccessibility() {
    this.$el.attr({
      'role': 'button',
      'aria-haspopup': 'dialog',
    })
  }

  toggle() {
    const { $siteNav, $hamburgerIcon, $closeIcon, navOverlay } = this.refs

    const openClass = 'site-nav--is-open'
    const isOpen = $siteNav.hasClass(openClass)

    if (isOpen) {
      $siteNav.slideUp(100)
      $siteNav.removeClass(openClass)
      $hamburgerIcon.show()
      $closeIcon.hide()
      $(document.body).removeClass('no-scroll')
    } else {
      $siteNav.slideDown(100)
      $siteNav.addClass(openClass)
      $hamburgerIcon.hide()
      $closeIcon.show()
      $(document.body).addClass('no-scroll')

      navOverlay.open()
    }
  }
}

customElements.define('nav-toggler', NavToggler)

class NavOverlay extends CustomElement {
  get refs() {
    const $navToggler = $('nav-toggler')
    return {
      $navToggler,
    }
  }

  constructor() {
    super()
  }

  open() {
    const { $navToggler } = this.refs

    this.$el.click(debounce(() => {
      this.$el.off('click')
      $navToggler.trigger('click')
    }, 100))
  }
}

customElements.define('nav-overlay', NavOverlay)

class SiteNav extends CustomElement {

  activeIndex = null

  isLoaded = false

  isOpen = false

  get refs() {
    const navDropdown = document.querySelector('nav-dropdown'),
      $navDropdown = $(navDropdown),
      $siteSubnav = $navDropdown.find('site-subnav')

    return {
      $navDropdown,
      navDropdown,
      $siteSubnav,
      siteSubnavEl: $siteSubnav.get(0),
    }
  }

  constructor() {
    super()
  }

  async prepare() {
    const { navDropdown } = this.refs

    navDropdown.open()

    await this.refs.navDropdown.loadSubnav()

    this.isLoaded = true
  }

  changeActive(index = 0) {
    this.activeIndex = index
  }

  open() {
    this.$el.slideDown(500)
    this.isOpen = true
  }

  close() {
    this.$el.slideUp(250)
    this.isOpen = false
  }
}

customElements.define('site-nav', SiteNav)

class SiteNavItem extends CustomElement {
  props = {
    index: 0,
    name: '',
    hasDropdown: false,
    isMinimal: false,
  }

  active = false

  get refs() {
    const $siteNav = this.$el.closest('site-nav'),
      siteNav = $siteNav.get(0)

    return {
      $siteNav,
      siteNav,
      ...$siteNav.get(0).refs,
    }
  }

  constructor() {
    super()
  }

  setup() {
    if (isMobileViewport()) {
      this.addEventListener('click', this.prepareMobileDropdown)
    } else {
      this.addEventListener('mouseover', debounce(this.onMouseOver.bind(this), 100))
    }
  }

  init() {
    super.init()

    this.$el.attr('aria-haspopup', true)
  }

  async onMouseOver() {
    const { siteNav, siteSubnavEl, navDropdown } = this.refs
    const { isMinimal, index } = this.props

    if (siteNav.activeIndex === index || isMinimal) return

    siteNav.changeActive(index)

    // if (!siteNav.isLoaded) {
    //     await siteNav.prepare();
    //
    //     if (!!siteSubnavEl) siteSubnavEl.eagerLoadSpotlight()
    //
    //     return
    // }

    navDropdown.open()
    siteSubnavEl.refresh()
  }

  async prepareMobileDropdown() {
    const { isMinimal } = this.props

    await this.clear()

    if (!!this.active) {
      this.active = false
      return
    }

    isMinimal ? this.toggleMinimalDropdown() : await this.openMobileDropdown()

    this.active = !this.active

    this.scrollIntoView({
      behavior: 'smooth',
    })
  }

  async clear() {
    const { $siteNav, siteNavItems, navDropdown } = this.refs

    this.$el.siblings().each(function () {
      this.active = false
    })
    await navDropdown.close()
    $siteNav.find('.minimal-nav-dropdown').each(function () {
      $(this).slideUp()
    })
  }

  async openMobileDropdown() {
    const { index } = this.props
    const { siteNav, navDropdown } = this.refs

    siteNav.changeActive(index)

    navDropdown.attach()

    // if (!siteNav.isLoaded) {
    //     await siteNav.prepare()
    // }

    await navDropdown.open()
  }

  toggleMinimalDropdown() {
    const $minimalDropdown = this.$el.find('.minimal-nav-dropdown')


    $minimalDropdown[this.active ? 'slideUp' : 'slideDown']()
  }
}

customElements.define('site-nav-item', SiteNavItem)

class NavDropdown extends CustomElement {

  isOpen = false

  get refs() {
    const siteNav = document.querySelector('site-nav'),
      $siteNav = $(siteNav),
      $siteSubnav = this.$el.find('site-subnav'),
      $cartToggler = $(document.querySelector('nav-toggler')),
      activeSiteNavItem = $siteNav.find(`site-nav-item[\\:index="${siteNav.activeIndex}"]`)
    return {
      $siteNav,
      siteNav,
      $siteSubnav,
      siteSubnavEl: $siteSubnav.get(0),
      $cartToggler,
      activeSiteNavItem,

    }
  }

  async loadSubnav() {
    const template = document.getElementById('site-subnav-tpl')

    if (!template) return

    setTimeout(() => {
      this.innerHTML = template.innerHTML
    }, 500)

    await $.getScript(Shop.assetUrl + 'site-subnav.js')
  }

  onMouseMove = debounce((e) => {
    const { siteNav } = this.refs

    const isOutside = (!this.contains(e.target) && !siteNav.contains(e.target)) || !!e.target.closest(`site-nav-item[\\:isMinimal="true"]`)

    if (isOutside) this.close()
  }, 100)

  attachIframeListeners() {
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach((iframe) => {
      iframe.addEventListener('mouseenter', () => {
        this.close();
      });
    });
  }

  open() {
    this.isOpen = true

    this.refs.activeSiteNavItem.addClass('is-open')

    this.$el.addClass('nav-dropdown--open')

    $(document).on('mousemove', this.onMouseMove)
    this.attachIframeListeners();
  }

  close() {
    const { siteNav } = this.refs

    this.isOpen = false

    $(document).off('mousemove')

    this.refs.activeSiteNavItem.removeClass('is-open')

    siteNav.activeIndex = null

    this.$el.removeClass('nav-dropdown--open');
  }

  attach() {
    const { activeSiteNavItem } = this.refs

    this.$el.detach().appendTo(activeSiteNavItem)
  }
}

customElements.define('nav-dropdown', NavDropdown)

class SiteSubnav extends CustomElement {
  parentIndex = null

  data = {
    title: '',
    url: '',
  }

  get refs() {
    const siteNav = document.querySelector('site-nav')

    return {
      $subNavItems: this.$el.find('site-subnav-item'),
      siteNav,
      mainNavigationMenu: JSON.parse(document.getElementById('main-navigation-menu').textContent),
    }
  }

  beforeMount() {
    super.beforeMount()

    this.getActiveNavLink()
  }

  mounted() {
    super.mounted()
  }

  refresh() {
    const { siteNav } = this.refs

    if (siteNav.activeIndex === this.parentIndex) return

    this.getActiveNavLink()

    this.render()
  }

  render() {
    this.innerHTML = this.template()
  }

  template() {
    if (!this.data) return null

    const { title, url } = this.data

    return `
        <div class="subnav-container ${title}" data-name="${title}">
            <nav-sidebar :parentIndex="${this.parentIndex}"></nav-sidebar>
        </div>

        <nav-spotlight class="spotlight" :parentIndex="${this.parentIndex}"></nav-spotlight>
    `
  }

  getActiveNavLink() {
    const { siteNav, mainNavigationMenu } = this.refs

    this.parentIndex = siteNav.activeIndex

    this.data = mainNavigationMenu[this.parentIndex]
  }
}

customElements.define('site-subnav', SiteSubnav)

class SiteSubavItem extends CustomElement {
  props = {
    path: '',
    index: 0,
  }

  data = {}

  get refs() {
    const $navSpotlight = this.$el.closest('site-subnav').find('nav-spotlight'),
      navSpotlight = $navSpotlight.get(0)
    return {
      navSpotlight,
      mainNavigationMenu: JSON.parse(document.getElementById('main-navigation-menu').textContent),
    }
  }

  constructor() {
    super()
  }

  setup() {
  }

  mounted() {
    super.mounted()
    this.$el.on('mouseover', this.renderSpotLight)
  }

  beforeMount() {
    super.beforeMount()
    const { mainNavigationMenu } = this.refs
    const { path } = this.props

    this.data = get(mainNavigationMenu, path)
  }

  renderSpotLight = debounce(() => {
    const { index } = this.props
    const { object, featuredImage, url, accentuate, primaryBadge, secondaryBadge } = this.data
    const { navSpotlight } = this.refs

    if (index === navSpotlight.activeIndex) return

    navSpotlight.activeIndex = index

    navSpotlight?.refresh({
      name: object.title,
      price: object.price,
      originalPrice: object.compare_at_price,
      url: url,
      featuredImage,
      accentuate,
      primaryBadge,
      secondaryBadge
    })

  }, 200)
}

customElements.define('site-subnav-item', SiteSubavItem)

class NavSidebar extends CustomElement {
  props = {
    parentIndex: 0,
  }

  get refs() {
    const siteNav = document.querySelector('site-nav')

    return {
      $subNavItems: this.$el.find('site-subnav-item'),
      siteNav,
      $navSpotlight: this.$el.find('nav-spotlight'),
      mainNavigationMenu: JSON.parse(document.getElementById('main-navigation-menu').textContent),
    }
  }

  async render() {
    if (!isMobileViewport()) {
      this.innerHTML = `<loading-overlay></loading-overlay>`
    }

    this.innerHTML = await this.template()

    this.populateSpotlight()
  }

  populateSpotlight() {
    const { $subNavItems, $navSpotlight } = this.refs

    const firstSubNavItem = $subNavItems.first().get(0)

    if ($navSpotlight.get(0)?.mounted) {
      firstSubNavItem?.renderSpotLight()
    } else {
      $navSpotlight.on('mounted', () => {
        firstSubNavItem?.renderSpotLight()

      })
    }
  }

  async template() {
    const { mainNavigationMenu } = this.refs
    const { parentIndex } = this.props

    this.data = mainNavigationMenu[parentIndex]

    if (!this.data) return null

    const { title, url } = this.data
    const navItems = await this.renderSubnavItems()
    const ctaLink = this.data.children.find(link => link.type !== "product_link")

    return `
      <p class="subnav-container__title paragraph-20 font-semibold">${title}</p>
      <ul class="subnav-container__links mt-3 lg:mt-0">${navItems.join('')}</ul>
      ${ctaLink ? `<a href="${ctaLink.url}" class="compare-btn btn btn--compact">${ctaLink.title}</a>` : ''}
    `
  }

  async renderSubnavItems() {
    const { children } = this.data
    const { parentIndex } = this.props

    const productLinks = children.filter(child => child.type === "product_link")

    return Promise.all(productLinks.map(async (childlink, i) => {
      return `<site-subnav-item
                :path="[${parentIndex}].children[${i}]"
                :index="${i}"
                class="site-subnav__item"
              >
                <a
                  href="${childlink.url}"
                  class="site-subnav__link"
                  ${childlink.active ? `aria-current="page"` : ''}
                  tabindex="-1"
                >
                  <div class="sub-item-content">
                     <div class="title_dis">
                      <p class="lg:font-semibold font-inter">
                        ${childlink.title}
                      </p>
                 ${childlink.subnavHtmlContent} 
                   </div>
              <img src="${childlink.submenuThumbImage}&transform=resize=600" class="spotlight__image w-full h-full object-contain" loading="lazy" />
                  </div>
                </a>
              </site-subnav-item>`
    }))
  }

}

customElements.define('nav-sidebar', NavSidebar)

class NavSpotlight extends CustomElement {
  props = {
    parentIndex: 0,
  }

  activeIndex = 0

  data = {
    name: '',
    price: '',
    originalPrice: '',
    imageUrl: null,
    url: '#',
    secondBadge: '',
    thirdBadge: '',
    fourthBadge: '',
    fifthBadge: '',
    isDiscounted: false,
    discountPercentage: 0
  }

  get refs() {
    return {
      mainNavigationMenu: JSON.parse(document.getElementById('main-navigation-menu').textContent),
    }
  }

  constructor() {
    super()
  }

  async connectedCallback() {
    this.extractProps()
    this.init()

    this.beforeMount()
    await this.render()

    setTimeout(() => {
      $(this).ready(this.mounted.bind(this))
    }, 0)
  }

  init() {
    super.init()
  }

  async render() {
    this.$el.css('opacity', 0)
    await wait(250)
    this.innerHTML = await this.template()
    this.$el.css('opacity', 1)
  }

  async mounted() {
    super.mounted()
    const { parentIndex } = this.props

    const path = `[${parentIndex}].children[0]`
    const { mainNavigationMenu } = this.refs

    const data = get(mainNavigationMenu, path)

    const { object, featuredImage, url, accentuate } = data

    await this.refresh({
      name: object.title,
      price: object.price,
      originalPrice: object.compare_at_price,
      url: url,
      featuredImage,
      secondBadge: accentuate?.second_badge || accentuate?.primary_badge || '',
      thirdBadge: accentuate?.third_badge || accentuate?.secondary_badge || '',
      fourthBadge: accentuate?.fourth_badge || '',
      fifthBadge: accentuate?.fifth_badge || '',
    })
  }

  async template() {
    if (!this.data.name) return
    const { name, price, originalPrice, url, imageUrl, secondBadge, thirdBadge, fourthBadge, fifthBadge, discountPercentage, isDiscounted } = this.data

    const MAX_BADGES = 2
    const badgeItems = []
    let badgeCount = 0

    if (isDiscounted && badgeCount < MAX_BADGES) {
      badgeItems.push(`<span class="rounded-full px-2 py-1 text-xs font-inter font-semibold bg-[var(--color-negative-500)] text-[var(--color-neutral-0)]">${discountPercentage}% 할인</span>`)
      badgeCount++
    }
    if (secondBadge && badgeCount < MAX_BADGES) {
      badgeItems.push(`<span class="rounded-full px-2 py-1 text-xs font-inter font-semibold bg-[var(--color-negative-200)] text-[var(--color-negative-600)] hidden md:inline">${secondBadge}</span>`)
      badgeCount++
    }
    if (thirdBadge && badgeCount < MAX_BADGES) {
      badgeItems.push(`<span class="rounded-full px-2 py-1 text-xs font-inter font-semibold bg-[var(--color-critical-500)] text-[var(--color-neutral-900)] hidden md:inline">${thirdBadge}</span>`)
      badgeCount++
    }
    if (fourthBadge && badgeCount < MAX_BADGES) {
      badgeItems.push(`<span class="rounded-full px-2 py-1 text-xs font-inter font-semibold bg-[var(--color-secondary-500)] text-[var(--color-neutral-0)] hidden md:inline">${fourthBadge}</span>`)
      badgeCount++
    }
    if (fifthBadge && badgeCount < MAX_BADGES) {
      badgeItems.push(`<span class="rounded-full px-2 py-1 text-xs font-inter font-semibold bg-[var(--color-positive-600)] text-[var(--color-neutral-0)] hidden md:inline">${fifthBadge}</span>`)
      badgeCount++
    }

    return `
      <div class="spotlight-media bg-wild-sand">
        <a href="${url}" class="spotlight__link relative">
          <div class="absolute left-2 top-2 md:left-3 md:top-3">
            <div class="flex flex-wrap gap-2">
              ${badgeItems.join('')}
            </div>
          </div>
          <img src="${imageUrl}" class="spotlight__image w-full h-full object-contain" loading="lazy" />
        </a>
      </div>

      <div class="spotlight-body">
        <a href="${url}" class="spotlight__link">
          <p class="spotlight__name text-xl font-semibold">${name}</p>
        </a>
        <div class="flex items-center gap-2 text-md">
          ${originalPrice ? `<span class="spotlight__original-price line-through text-xs">${originalPrice.toLocaleString()}원</span>` : ''}
          ${originalPrice ? `<p class="inline"></p> ` : ''}<span class="spotlight__price text-scarlet font-bold">${price.toLocaleString()}원</span>
        </div>
      </div>
    `
  }

  async refresh({ name, price, url, originalPrice, featuredImage, secondBadge, thirdBadge, fourthBadge, fifthBadge }) {
    this.data.name = name
    this.data.price = (price / 100)
    this.data.originalPrice = originalPrice ? (originalPrice / 100) : null
    this.data.imageUrl = featuredImage
    this.data.url = url
    this.data.secondBadge = secondBadge || ''
    this.data.thirdBadge = thirdBadge || ''
    this.data.fourthBadge = fourthBadge || ''
    this.data.fifthBadge = fifthBadge || ''
    this.data.isDiscounted = price < originalPrice
    this.data.discountPercentage = this.data.isDiscounted ? Math.round(((originalPrice - price) / originalPrice) * 100) : 0
    await this.render()
  }
}

customElements.define('nav-spotlight', NavSpotlight)
